import { getCurrentRole } from '@/lib/utils.ts'
import { NavigationDataT } from '../types/navigationTypes'

// Filter out link groups that the user does not have access to
// this can also be done on a per-link basis
export function removeNotAllowedGroups(navigationData: NavigationDataT) {
  const role = getCurrentRole()
  const navigationGroupsKeys = Object.keys(navigationData)

  const allowedNavigationGroups = navigationGroupsKeys.filter(
    key =>
      !navigationData[key].allowedRoles ||
      (role && navigationData[key].allowedRoles.includes(role)),
  )
  return { navigationGroupsKeys, allowedNavigationGroups }
}
